import React,{useEffect} from "react";
import styled from "styled-components";
import { Button } from "@material-ui/core";
import ProjectCard from "./ProjectCard";
import bac1 from "../images/disnep.png";
import bank from "../images/Bank Project.png";
import blog from "../images/blog website.png";
import browser from "../images/browser.png";
import calc from "../images/calculator.png";
import college from "../images/college.png";
import dice from "../images/dice game.png";
import drums from "../images/drums game.png";
import keep from "../images/googlekeep clone.png";
import guess from "../images/guess number.png";
import jarvis from "../images/jarvis.png";
import notepad from "../images/notepad.png";
import pig from "../images/pig game.png";
import simon from "../images/simon game.png";
import tesla from "../images/tesla clone.png";
import tic from "../images/tik tac toe.png";
import tindog from "../images/tindog clone.png";
import todo1 from "../images/todolist1 clone.png";
import todo2 from "../images/todolist2 clone.png";
import univer from "../images/university design.png";
import whatsapp from "../images/whatsapp clone.png";
import youtube from "../images/youtube clone.png";
import mapty from "../images/mapty.png";
import tensor from "../images/tensor.png";
import python from "../images/python-projects.jpg";
import tracker from "../images/tracker.png";
import micro from "../images/microsoft-todo.png";
import speechml from "../images/speechml.png";
import luckydraw from "../images/lucky_draw.png";
import reactnativetodo from "../images/react-native-todo.png";
import mypathguider from "../images/mypathguider.png";
import disease_detection from "../images/disease-detection.png";
import opengl_house from "../images/opengl-house.png";
import houseprice from "../images/houseprice.jpg";
import cropprice from "../images/crop.jpg";
import medicalexpenses from "../images/medicalexpenses.jpg";
import dementia from "../images/dementia.png";
import alzheimer from "../images/alzheimer.png";
import spam from "../images/spamemail.jpg";
import drugs from "../images/drugs.jpg";
import loan from "../images/loan.jpg";
import brain from "../images/braintumor.jpg";
import faceemotion from "../images/facialemotion.jpg";
import facerecognition from "../images/facialrecognition.jpg";
import gan from "../images/gan.png";
import signlanguage from "../images/signlanguage.png";
import stock from "../images/stockmarket.jpeg";
import imdb from "../images/imdb.png";
import textgeneration from "../images/text_generation.png";
import { Link } from "react-router-dom";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
function Projects() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Container>
      <Link to={`/`}>
        <Button id="11"> Back To Home</Button>
      </Link>
      <Link to={"/certificates"}>
        <Button>My Certificates</Button>
      </Link>
      <h1
        style={{
          letterSpacing: "5px",
          color: "white",
          fontFamily: "'Pattaya', sans-serif",
          textTransform: "uppercase",
          fontSize: "3rem",
        }}
      >
        MY PROJECTS
      </h1>
      <div className="projects">
        <ProjectCard
          title="Medical Diagnosis App"
          techused={[
            "Logistic Regression",
            "Random Forest Classifier",
            "FLASK, HTML, CSS",
            "Decision Trees",
          ]}
          bacimg={disease_detection}
          linkto="https://youtu.be/VmipKjnYaTs"
        />
        <ProjectCard
          title="House price prediction"
          techused={[
            "Linear Regression",
            "Train Test split",
            "Machine learning",
          ]}
          bacimg={houseprice}
          linkto="https://github.com/vishnu305/House-price-prediction"
        />
        <ProjectCard
          title="Crop price prediction"
          techused={[
            "Linear Regression",
            "Train Test split",
            "Matplotlib",
            "Machine learning",
          ]}
          bacimg={cropprice}
          linkto="https://github.com/vishnu305/prediction_of_crop_price"
        />
        <ProjectCard
          title="Medical expenses prediction"
          techused={[
            "Linear Regression",
            "Train Test split",
            "Matplotlib",
            "Machine learning",
          ]}
          bacimg={medicalexpenses}
          linkto="https://github.com/vishnu305/Medical-expenses-prediction"
        />
        <ProjectCard
          title="Dementia classification"
          techused={[
            "Random Forest classifier",
            "Tensorflow",
            "Deep Face",
            "Flask",
          ]}
          bacimg={dementia}
          linkto="https://github.com/vishnu305/dementia_web_app_flask"
        />
        <ProjectCard
          title="Alzheimer checkup"
          techused={[
            "Python",
            "Tkinter",
            "cv2",
            "Flask",
          ]}
          bacimg={alzheimer}
          linkto="https://github.com/vishnu305/dementia_checkup_app"
        />
        <ProjectCard
          title="Spam email Prediction"
          techused={[
            "Naive Bayes classifier",
            "Count Vectorizer",
            "Pickle",
            "Text classfication",
          ]}
          bacimg={spam}
          linkto="https://github.com/vishnu305/spam-email-classification"
        />
        <ProjectCard
          title="Drugs case genuinity"
          techused={[
            "LSTM",
            "Embedding vector",
            "Random Forest classifier",
            "Tokenizer, Count vectorizer",
          ]}
          bacimg={drugs}
          linkto="https://github.com/vishnu305/drugs-case-genuinity"
        />
        <ProjectCard
          title="Loan Data classification"
          techused={[
            "Numpy, pandas",
            "Matplotlib",
            "Random Forest classifier",
            "Train test split",
          ]}
          bacimg={loan}
          linkto="https://github.com/vishnu305/Loan-data-classification"
        />
        <ProjectCard
          title="Brain Tumor recognition"
          techused={[
            "Tensorflow",
            "CNN",
            "cv2, matplotlib, os",
            "Neural network",
          ]}
          bacimg={brain}
          linkto="https://github.com/vishnu305/Brain-tumor-recognition"
        />
        <ProjectCard
          title="Facial Emotion recognition"
          techused={[
            "Tensorflow",
            "CNN",
            "cv2, matplotlib, os",
            "Neural network",
          ]}
          bacimg={faceemotion}
          linkto="https://github.com/vishnu305/Facial-Emotion-Recognition"
        />
        <ProjectCard
          title="Face recognition"
          techused={[
            "Tensorflow",
            "CNN, LSTM, Siamese model",
            "cv2, matplotlib, os",
            "Neural network",
          ]}
          bacimg={facerecognition}
          linkto="https://github.com/vishnu305/Facial_recognition_using_siamese_model"
        />
        <ProjectCard
          title="GAN on mnist data"
          techused={[
            "Tensorflow, Generative Adversial networks",
            "CNN, LSTM",
            "cv2, matplotlib, os",
            "Neural network",
          ]}
          bacimg={gan}
          linkto="https://github.com/vishnu305/GAN-mnist-data"
        />
        <ProjectCard
          title="Sign language detection"
          techused={[
            "Tensorflow, Media pipe holistic",
            "CNN, LSTM",
            "cv2, matplotlib, os",
            "Neural network",
          ]}
          bacimg={signlanguage}
          linkto="https://github.com/vishnu305/Sign-language-detection"
        />
        <ProjectCard
          title="Stock market prediction"
          techused={[
            "Tensorflow",
            "LSTM",
            "Neural network",
          ]}
          bacimg={stock}
          linkto="https://github.com/vishnu305/stock_market_prediction-using-lstm"
        />
        <ProjectCard
          title="Object Detection"
          techused={["Tensor Flow", "ssd model", "yolov5 model", "cv2, matplotlib"]}
          bacimg={tensor}
          linkto="https://github.com/vishnu305/Object-detction-using-ssd-yolo"
        />
        <ProjectCard
          title="IMDB Sentimental Analysis"
          techused={["Tensor Flow", "LSTM", "Word embedding", "GRU, Conv1D, GlobalAveragepooling1D"]}
          bacimg={imdb}
          linkto="https://github.com/vishnu305/IMDB-sentiment-analysis"
        />
        <ProjectCard
          title="Text generation LSTM"
          techused={["Tensor Flow", "LSTM", "Word embedding", "GRU, Conv1D, GlobalAveragepooling1D"]}
          bacimg={textgeneration}
          linkto="https://github.com/vishnu305/Text-generation-using-lstm"
        />







        <ProjectCard
          title="Disnep Clone"
          techused={["React", "HTML", "CSS", "JavaScript"]}
          bacimg={bac1}
          linkto="https://github.com/vishnu305/disnep-clone"
        />
        <ProjectCard
          title="Microsoft Todo Clone"
          techused={["React", "Mongoose", "HTML, CSS", "JavaScript"]}
          bacimg={micro}
          linkto="https://www.youtube.com/watch?v=9_mtKKxM4lk&t=2s"
        />
        <ProjectCard
          title="Covid-19 Tracker"
          techused={["React", "leaflet", "API", "Material-Ui"]}
          bacimg={tracker}
          linkto="https://covid19tracker-vishnuproject.netlify.app/"
        />
        {/* <ProjectCard
          title="Speech Emotion Recognition"
          techused={[
            "Machine Learning Model",
            "Keras",
            "librosa",
            "MLPClassifier",
          ]}
          bacimg={speechml}
          linkto="https://github.com/vishnu305/Speech-Emotion-Recognition---Machine-Learning-Project"
        /> */}
        
        <ProjectCard
          title="Tesla Landing Page"
          techused={["React", "HTML", "CSS", "JavaScript"]}
          bacimg={tesla}
          linkto="https://github.com/vishnu305/tesla-clone"
        />
        <ProjectCard
          title="Youtube Clone"
          techused={["React", "HTML", "CSS", "JavaScript"]}
          bacimg={youtube}
          linkto="https://github.com/vishnu305/youtube-clone"
        />
        {/* <ProjectCard
          title="Whatsapp Clone"
          techused={["React", "HTML-CSS", "Google Firebase", "JavaScript"]}
          bacimg={whatsapp}
          linkto="https://github.com/vishnu305/whatsapp-clone"
        /> */}
        {/* <ProjectCard
          title="Internship in MyPathGuider"
          techused={["Docusauraus JS", "React JS", "Node JS", "Express JS"]}
          bacimg={mypathguider}
          linkto="https://mypathguider.com"
        /> */}
        
        <ProjectCard
          title="React Native Todo"
          techused={["React Native", "React Hooks", "Components", "JavaScript"]}
          bacimg={reactnativetodo}
          linkto="https://github.com/vishnu305/react-native-todo"
        />
        <ProjectCard
          title="Tindog Design"
          techused={["HTML", "CSS", "JavaScript", ""]}
          bacimg={tindog}
          linkto="https://github.com/vishnu305/tindog"
        />
        <ProjectCard
          title="Open GL House"
          techused={["Open GL", "freeGlut", "C++", "Computer Graphics"]}
          bacimg={opengl_house}
          linkto="https://youtu.be/jdQxHxGm00M"
        />
        <ProjectCard
          title="Blog Website"
          techused={["Node js", "HTML-CSS", "JavaScript", "Mongoose"]}
          bacimg={blog}
          linkto="https://github.com/vishnu305/blog-website"
        />
        <ProjectCard
          title="Todolist App"
          techused={["Node js", "HTML-CSS", "Mongoose", "JavaScript"]}
          bacimg={todo1}
          linkto="https://github.com/vishnu305/todolist1"
        />
        <ProjectCard
          title="Todolist App2"
          techused={["React", "HTML-CSS", "Mongoose", "JavaScript"]}
          bacimg={todo2}
          linkto="https://codesandbox.io/s/es6-spread-operator-practice-forked-vnxp6"
        />
        <ProjectCard
          title="GoogleKeep Clone"
          techused={["React", "HTML-CSS", "Mongoose", "JavaScript"]}
          bacimg={keep}
          linkto="https://github.com/vishnu305/googlekeep-clone"
        />
        {/* <ProjectCard
          title="GoogleMaps Clone"
          techused={["HTML", "CSS", "JavaScript", ""]}
          bacimg={mapty}
          linkto="https://github.com/vishnu305/googlemaps-clone"
        /> */}
        <ProjectCard
          title="University LandingPage"
          techused={["", "HTML", "CSS", "JavaScript"]}
          bacimg={univer}
          linkto="https://github.com/vishnu305/universitylandingpage"
        />
        {/* <ProjectCard
          title="Dice Game(pig)"
          techused={["", "HTML", "CSS", "JavaScript"]}
          bacimg={pig}
          linkto="https://github.com/vishnu305/pigdicegame"
        /> */}
        {/* <ProjectCard
          title="Simon Game"
          techused={["", "HTML", "CSS", "JavaScript"]}
          bacimg={simon}
          linkto="https://github.com/vishnu305/simongame"
        />
        <ProjectCard
          title="Dice Game"
          techused={["", "HTML", "CSS", "JavaScript"]}
          bacimg={dice}
          linkto="https://github.com/vishnu305/dicegame"
        /> */}
        {/* <ProjectCard
          title="Guess Number Game"
          techused={["", "HTML", "CSS", "JavaScript"]}
          bacimg={guess}
          linkto="https://github.com/vishnu305/guessmynumbergame"
        /> */}
        {/* <ProjectCard
          title="Drums Game"
          techused={["", "HTML", "CSS", "JavaScript"]}
          bacimg={drums}
          linkto="https://github.com/vishnu305/drums-game"
        /> */}
        <ProjectCard
          title="Lucky Draw Ethereum"
          techused={["Block Chain", "Ethereum", "Solidity", "Payable Contract"]}
          bacimg={luckydraw}
          linkto="https://github.com/vishnu305/Block-Chain-Project-Lucky-Draw-Contract"
        />
        <ProjectCard
          title="Bank Project"
          techused={["Python", "Tkinter", "Sqlite3", ""]}
          bacimg={bank}
          linkto="https://github.com/vishnu305/bankproject"
        />
        <ProjectCard
          title="College Management System"
          techused={["Python", "Tkinter", "Sqlite3", ""]}
          bacimg={college}
          linkto="https://github.com/vishnu305/college-management-system"
        />
        <ProjectCard
          title="Scientific Calculator"
          techused={["Python", "Tkinter", "Sqlite3", ""]}
          bacimg={calc}
          linkto="https://github.com/vishnu305/scientific-calculator"
        />
        <ProjectCard
          title="Notepad"
          techused={["Python", "Tkinter", "Sqlite3", ""]}
          bacimg={notepad}
          linkto="https://github.com/vishnu305/notepad"
        />
        <a href="#11">
          <KeyboardArrowUpIcon
            style={{ fontSize: "50px" }}
            className="arrow-up1"
          />
        </a>
        <ProjectCard
          title="Jarvis A.I Personal Assistent"
          techused={["Python", "PyQt5", "Sqlite3", "More modules in python..."]}
          bacimg={jarvis}
          linkto="https://github.com/vishnu305/jarvis-A.I"
        />
        <ProjectCard
          title="Browser Using Python"
          techused={["Python", "PyQt5", "Tkinter"]}
          bacimg={browser}
          linkto="https://github.com/vishnu305/browser-python"
        />
        <ProjectCard
          title="Tic Tac Toe with PC"
          techused={["Python", "Tkinter", "Sqlite3", ""]}
          bacimg={tic}
          linkto="https://github.com/vishnu305/tic-tac-toe-with-pc"
        />
        {/* <ProjectCard
          title="My all python Projects"
          techused={["Python", "", "", ""]}
          bacimg={python}
          linkto="https://github.com/vishnu305/python-projects1"
        /> */}
      </div>
    </Container>
  );
}

export default Projects;
const Container = styled.div`
  /* height: 100vh; */
  background: linear-gradient(to right, #cc2b5e, #753a88);
  Button {
    text-decoration: none;
    background: red;
    /* background: linear-gradient(90deg,#03a9f4,#f441a5,#ffeb3b,#03a9f4); */
    /* background-size: 400%; */
    color: white;
    margin-top: 30px;
    transform: translate(-50%, -50%);
    animation: animateDown infinite 1.5s;
    &:hover {
      background: black;
    }
    margin-left: 20%;
    margin-right: 20%;
  }
  .arrow-up1 {
    color: white;
    animation: animateDown infinite 1.5s;
    position: relative;
    bottom: 100px;
    left: 48%;
    background: transparent;
    position: fixed;
  }
  .projects {
    display: flex;
    flex-wrap: wrap;
  }
`;
